import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-duplicate',
  templateUrl: './duplicate.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DuplicateComponent {}
